import React, {useEffect, useState} from "react"
import {Field, Fields, FieldsGroup} from "../../lib/wa-2.0"
import AppSettingsApi from "../../api/AppSettingsApi"
import {noticeController} from "../../utils/NoticeController"
import {observer} from "mobx-react-lite"
import CommandField from "../../components/task_buttons/CommandField";
import {appPages} from "../../App"

export const AuthPage = observer(() => {
    const [clientId, setClientId] = useState("")
    const [apiKey, setApiKey] = useState("")
    const [commandData, setCommandData] = useState('')
    const [result, setResult] = useState({success: false, wasRequest: false})
    const [logging, setLogging] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        AppSettingsApi.getAuthConfig().then((value => {
            const appSettings = value.data.data;
            setClientId(appSettings.config.clientId)
            setApiKey(appSettings.config.apiKey)
            setLogging(appSettings.logging)
            setCommandData(appSettings.heartbeatCommand)
        }))
    }, [])

    return <>
        <h1>Настройки API</h1>
        <div className="custom-mb-32">
            В личном кабинете OZON перейдите в <a href="https://seller.ozon.ru/app/settings"
                                                  target={"_blank"} rel="noopener noreferrer">настройки</a>, на вкладку
            API-ключи и создайте
            API-ключ.
        </div>
        <Fields>
            <FieldsGroup>
                <Field label={"Client id:"} labelStyles={{width: "75px"}}>
                    <input
                        className={"long"}
                        onChange={e => setClientId(e.target.value)}
                        type="text"
                        value={clientId || ""}
                    />
                </Field>
                <Field label={"Api-Key:"} labelStyles={{width: "75px"}}>
                    <input
                        className={"long"}
                        onChange={e => setApiKey(e.target.value)}
                        type="text"
                        value={apiKey || ""}
                    />

                </Field>
                <Field label={"Логирование: "} labelStyles={{width: "75px"}}>
                    <label className={"custom-ml-8"}>
                        <span className="wa-checkbox">
                                <input
                                    onChange={e => {
                                        setLogging(e.target.checked)
                                        AppSettingsApi.setLogging(e.target.checked)
                                    }}
                                    type="checkbox"
                                    checked={logging}
                                />
                            <span>
                                <span className="icon">
                                    <i className="fas fa-check"/>
                                </span>
                            </span>
                        </span>
                    </label>
                </Field>
            </FieldsGroup>

            <div className={"custom-mt-40"}>
                <button
                    className={isLoading ? "button disabled" : "button"}
                    onClick={() => {
                        if (isLoading) {
                            return
                        }
                        // @ts-ignore
                        const waLoading = $.waLoading()

                        setIsLoading(true)

                        waLoading.animate(40000, 90, false)
                        AppSettingsApi.setAuthConfig(apiKey, clientId).then(response => {
                            setIsLoading(false)
                            const isSuccess = response.data.status === "ok"
                            waLoading.set(100)
                            setResult({
                                wasRequest: true,
                                success: isSuccess
                            })
                            if (isSuccess) {
                                noticeController.clear()
                                noticeController.success = [response.data.data]
                                waLoading.done()
                            } else {
                                noticeController.clear()
                                noticeController.errors.push({message: "Не удалось авторизоваться, проверьте правильность токена", fixPath: appPages.apiSettings})
                                waLoading.abort()
                            }
                        })
                    }}
                >
                    Авторизоваться{!isLoading && result.wasRequest && result.success &&
                    <i className={"fas fa-check-circle custom-ml-4"}/>}
                </button>
            </div>
            <FieldsGroup>
                <Field label={"Запуск задач"}>
                    <CommandField command={'* * * * * ' + commandData}/>
                    <div className={'hint'}>Чтобы запускать некоторые задачи может понадобится крон</div>
                </Field>
            </FieldsGroup>
        </Fields>
    </>

})